const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300px",
    height: "300px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#10c9ac",
    d: "M 34.5,-0.5 C 90.5,-0.5 146.5,-0.5 202.5,-0.5C 211.238,3.07474 217.072,9.40807 220,18.5C 220.5,31.1623 220.667,43.8289 220.5,56.5C 258.04,64.2068 281.873,86.5402 292,123.5C 298.748,164.485 284.915,196.319 250.5,219C 241.368,223.988 231.702,227.488 221.5,229.5C 220.947,247.542 220.113,265.542 219,283.5C 215.472,291.535 209.639,296.868 201.5,299.5C 145.833,299.5 90.1667,299.5 34.5,299.5C 25.7617,295.925 19.9284,289.592 17,280.5C 16.3333,193.167 16.3333,105.833 17,18.5C 19.2506,8.75346 25.0839,2.42013 34.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 43.5,23.5 C 93.1678,23.3333 142.834,23.5 192.5,24C 195.232,24.3981 197.065,25.8981 198,28.5C 198.5,37.8274 198.666,47.1607 198.5,56.5C 157.5,62.3273 131.667,85.3273 121,125.5C 115.084,175.524 135.584,209.357 182.5,227C 187.73,228.546 193.063,229.38 198.5,229.5C 198.666,234.844 198.499,240.177 198,245.5C 197.06,248.773 194.893,250.606 191.5,251C 142.167,251.667 92.8333,251.667 43.5,251C 41.2739,249.773 39.7739,247.939 39,245.5C 38.3333,173.167 38.3333,100.833 39,28.5C 40.025,26.313 41.525,24.6464 43.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2cccb1",
    d: "M 71.5,78.5 C 78.175,78.3337 84.8417,78.5004 91.5,79C 96.1433,81.0724 97.6433,84.5724 96,89.5C 95.1667,91.6667 93.6667,93.1667 91.5,94C 84.8333,94.6667 78.1667,94.6667 71.5,94C 66.4648,90.9867 65.2981,86.8201 68,81.5C 69.1451,80.3636 70.3117,79.3636 71.5,78.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfefe",
    d: "M 198.5,82.5 C 224.658,80.9915 236.658,93.3249 234.5,119.5C 237.85,119.335 241.183,119.502 244.5,120C 246.492,120.574 247.992,121.741 249,123.5C 249.667,143.5 249.667,163.5 249,183.5C 248.167,185.667 246.667,187.167 244.5,188C 218.833,188.667 193.167,188.667 167.5,188C 166,187.167 164.833,186 164,184.5C 163.333,163.833 163.333,143.167 164,122.5C 164.903,121.299 166.069,120.465 167.5,120C 171.152,119.501 174.818,119.335 178.5,119.5C 175.561,101.697 182.228,89.3633 198.5,82.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#19caad",
    d: "M 201.5,91.5 C 219.704,91.8443 227.704,101.178 225.5,119.5C 212.833,119.5 200.167,119.5 187.5,119.5C 185.337,106.491 190.004,97.1573 201.5,91.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1ccaae",
    d: "M 70.5,112.5 C 77.8409,112.334 85.1742,112.5 92.5,113C 97.8119,117.572 97.8119,122.239 92.5,127C 85.1667,127.667 77.8333,127.667 70.5,127C 65.2018,122.092 65.2018,117.258 70.5,112.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#18c9ad",
    d: "M 211.5,168.5 C 208.167,168.5 204.833,168.5 201.5,168.5C 201.817,164.298 201.483,160.298 200.5,156.5C 195.208,150.665 195.208,144.832 200.5,139C 213.368,135.868 218.201,140.701 215,153.5C 214,154.5 213,155.5 212,156.5C 211.501,160.486 211.334,164.486 211.5,168.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1bcaae",
    d: "M 71.5,145.5 C 78.175,145.334 84.8417,145.5 91.5,146C 96.1433,148.072 97.6433,151.572 96,156.5C 95.5,158.333 94.3333,159.5 92.5,160C 85.1667,160.667 77.8333,160.667 70.5,160C 65.068,154.761 65.4013,149.928 71.5,145.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#89e4d6",
    d: "M 200.5,156.5 C 201.483,160.298 201.817,164.298 201.5,168.5C 204.833,168.5 208.167,168.5 211.5,168.5C 208.038,169.482 204.371,169.815 200.5,169.5C 200.5,165.167 200.5,160.833 200.5,156.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#28cbb0",
    d: "M 71.5,178.5 C 78.175,178.334 84.8417,178.5 91.5,179C 96.2238,181.435 97.7238,185.269 96,190.5C 94.786,192.049 93.286,193.215 91.5,194C 84.8333,194.667 78.1667,194.667 71.5,194C 66.4648,190.987 65.2981,186.82 68,181.5C 69.5185,180.837 70.6851,179.837 71.5,178.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 83.5,266.5 C 88.5,266.5 93.5,266.5 98.5,266.5C 98.5,271.5 98.5,276.5 98.5,281.5C 93.5,281.5 88.5,281.5 83.5,281.5C 83.5,276.5 83.5,271.5 83.5,266.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 113.5,266.5 C 118.167,266.5 122.833,266.5 127.5,266.5C 127.5,271.5 127.5,276.5 127.5,281.5C 122.833,281.5 118.167,281.5 113.5,281.5C 113.5,276.5 113.5,271.5 113.5,266.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 143.5,266.5 C 148.167,266.5 152.833,266.5 157.5,266.5C 157.5,271.5 157.5,276.5 157.5,281.5C 152.833,281.5 148.167,281.5 143.5,281.5C 143.5,276.5 143.5,271.5 143.5,266.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.9ae4199115286cd7a69c52638ab36899.svg";
export { ForwardRef as ReactComponent };